import { styled } from '@mui/system';
import { theme } from 'oems/theme';

import SearchIcon from '@mui/icons-material/Search';

import * as DocumentPreviewStyles from 'components/ui/documentPreview/DocumentPreview.styles';

export const Root = styled(DocumentPreviewStyles.Root)``;
export const SideCard = styled(DocumentPreviewStyles.SideCard)``;
export const VerticalLeftAligned = styled(DocumentPreviewStyles.VerticalLeftAligned)``;
export const Divider = styled(DocumentPreviewStyles.Divider)``;

export const Card = styled(DocumentPreviewStyles.Card)`
  padding: 20px;
`;

export const Title = styled('div')`
  font-size: 18px;
  color: ${theme.palette.text.dark};
  font-weight: 700;

  &.small {
    font-size: 16px;
    margin-top: 4px;
  }
`;

export const Files = styled('div')`
  width: 100%;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const PreviewIcon = styled(SearchIcon)`
  color: ${theme.palette.black.main};
`;

export const File = styled('div')`
  width: 100%;
  color: ${theme.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    color: ${theme.palette.primary.focus};
  }

  span {
    width: calc(100% - 28px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Actions = styled('div')`
  width: 100%;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const Button = styled('div')`
  width: 100%;
  color: ${theme.palette.secondary.main};
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  padding: 2px 8px;

  &.danger {
    color: ${theme.palette.error.main};
  }

  svg {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
`;

export const PreviewPlaceholder = styled('div')`
  color: ${theme.palette.secondary.main};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  height: 200px;

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const Pdf = styled('object')`
  width: 100%;
  min-height: 600px;
  display: block;
`;
